"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _commonAccordion = require("@mmc/common-accordion");

var _commonCta = require("@mmc/common-cta");

var _commonRichText = require("@mmc/common-rich-text");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactRedux = require("react-redux");

var _commonI18n = require("@mmc/common-i18n");

var _text = require("@mmc/text");

var _configuratorSmallSummary = _interopRequireDefault(require("../styles/configurator-small-summary.css"));

var _configuratorSmallSummary2 = _interopRequireWildcard(require("./configurator-small-summary.props/configurator-small-summary.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    isEmptyArray = dataUtils.isEmptyArray;

var convertToCapitalizedCase = function convertToCapitalizedCase(str) {
  return str.split(' ').map(function (w) {
    return w && w[0] ? w[0].toUpperCase() + w.substr(1).toLowerCase() : '';
  }).join(' ');
};

var getPanelData = function getPanelData(params) {
  var market = params.market,
      color = params.color,
      fabric = params.fabric,
      packages = params.packages,
      accessories = params.accessories,
      includedText = params.includedText,
      changeText = params.changeText,
      changeColor = params.changeColor,
      changeFabric = params.changeFabric,
      changePackage = params.changePackage,
      changeAccessories = params.changeAccessories,
      totalPrice = params.totalPrice,
      baseMsrpLabel = params.baseMsrpLabel,
      additionalPriceGroup = params.additionalPriceGroup,
      destinationFeesLabel = params.destinationFeesLabel;
  var panels = [];
  var destinationFees = additionalPriceGroup.destinationFees;
  var sumOfAdditionalPrices = additionalPriceGroup ? additionalPriceGroup.color + additionalPriceGroup.fabric + additionalPriceGroup["package"] + additionalPriceGroup.accessory + destinationFees : 0;

  if (market === 'us' && totalPrice && totalPrice.baseValue !== 0 && additionalPriceGroup) {
    panels.push({
      id: 'basemsrp',
      includedText: '',
      changeText: '',
      header: {
        label: baseMsrpLabel,
        price: totalPrice.value - sumOfAdditionalPrices
      },
      body: {
        description: '',
        changeEvent: null
      }
    });
  }

  if (color) {
    if (color.code) {
      panels.push({
        id: 'color',
        includedText: includedText,
        changeText: changeText,
        header: {
          label: convertToCapitalizedCase(handleNestedProp(color, 'color.label')) + " ",
          price: handleNestedProp(color, 'color.price.value')
        },
        body: {
          description: handleNestedProp(color, 'color.titleAndText.text'),
          changeEvent: changeColor
        }
      });
    }
  }

  if (fabric) {
    if (fabric.code) {
      panels.push({
        id: 'fabric',
        includedText: includedText,
        changeText: changeText,
        header: {
          label: convertToCapitalizedCase(handleNestedProp(fabric, 'fabric.label')) + " ",
          price: handleNestedProp(fabric, 'fabric.price.value')
        },
        body: {
          description: handleNestedProp(fabric, 'fabric.titleAndText.text'),
          changeEvent: changeFabric
        }
      });
    }
  }

  if (packages) {
    packages.forEach(function (currentPackage, i) {
      panels.push({
        id: "packages-" + i,
        includedText: includedText,
        changeText: changeText,
        header: {
          label: handleNestedProp(currentPackage, 'currentPackage.label') + " ",
          price: handleNestedProp(currentPackage, 'currentPackage.price.value')
        },
        body: {
          description: handleNestedProp(currentPackage, 'currentPackage.titleAndText.text'),
          changeEvent: changePackage
        }
      });
    });
  }

  if (accessories) {
    accessories.forEach(function (currentAccessory, i) {
      panels.push({
        id: "accessories-" + i,
        includedText: includedText,
        changeText: changeText,
        header: {
          label: handleNestedProp(currentAccessory, 'currentAccessory.label') + " ",
          price: handleNestedProp(currentAccessory, 'currentAccessory.price.value')
        },
        body: {
          description: handleNestedProp(currentAccessory, 'currentAccessory.titleAndText.text'),
          changeEvent: changeAccessories
        }
      });
    });
  }

  if (market === 'us' && destinationFees && destinationFees !== 0) {
    panels.push({
      id: 'fees',
      includedText: '',
      changeText: '',
      header: {
        label: destinationFeesLabel,
        price: destinationFees
      },
      body: {
        description: '',
        changeEvent: null
      }
    });
  }

  return panels;
};

var AccordionWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(AccordionWrapper, _React$Component);

  AccordionWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var data = props.data,
        config = props.config,
        changeColor = props.changeColor,
        changeFabric = props.changeFabric,
        changePackage = props.changePackage,
        changeAccessories = props.changeAccessories,
        additionalPriceGroup = props.additionalPriceGroup;
    var color = data.color,
        fabric = data.fabric,
        packages = data.packages,
        accessories = data.accessories,
        includedText = data.includedText,
        changeText = data.changeText,
        totalPrice = data.totalPrice,
        baseMsrpLabel = data.baseMsrpLabel,
        destinationFeesLabel = data.destinationFeesLabel;
    var market = config.market;
    var panelData = getPanelData({
      market: market,
      color: color,
      fabric: fabric,
      packages: packages,
      accessories: accessories,
      includedText: includedText,
      changeText: changeText,
      changeColor: changeColor,
      changeFabric: changeFabric,
      changePackage: changePackage,
      changeAccessories: changeAccessories,
      totalPrice: totalPrice,
      baseMsrpLabel: baseMsrpLabel,
      additionalPriceGroup: additionalPriceGroup,
      destinationFeesLabel: destinationFeesLabel
    });
    return {
      panelData: panelData
    };
  };

  function AccordionWrapper(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var data = props.data,
        config = props.config,
        changeColor = props.changeColor,
        changeFabric = props.changeFabric,
        changePackage = props.changePackage,
        changeAccessories = props.changeAccessories,
        additionalPriceGroup = props.additionalPriceGroup;
    var color = data.color,
        fabric = data.fabric,
        packages = data.packages,
        accessories = data.accessories,
        includedText = data.includedText,
        changeText = data.changeText,
        totalPrice = data.totalPrice,
        baseMsrpLabel = data.baseMsrpLabel,
        destinationFeesLabel = data.destinationFeesLabel;
    var market = config.market;
    var panelData = getPanelData({
      color: color,
      fabric: fabric,
      packages: packages,
      accessories: accessories,
      includedText: includedText,
      changeText: changeText,
      changeColor: changeColor,
      changeFabric: changeFabric,
      changePackage: changePackage,
      changeAccessories: changeAccessories,
      market: market,
      totalPrice: totalPrice,
      baseMsrpLabel: baseMsrpLabel,
      additionalPriceGroup: additionalPriceGroup,
      destinationFeesLabel: destinationFeesLabel
    });
    _this.state = {
      panelData: panelData
    };
    return _this;
  }

  var _proto = AccordionWrapper.prototype;

  _proto.renderPrice = function renderPrice(price, text, config) {
    if (price === 0) {
      return text;
    }

    return /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: price,
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode')
      }
    });
  };

  _proto.renderPanels = function renderPanels(panelData, config) {
    var _this2 = this;

    if (panelData === void 0) {
      panelData = [];
    }

    var panelMarkup = [];
    panelData.forEach(function (panel) {
      panelMarkup.push(_this2.renderPanelHeader(panel, config));
      panelMarkup.push(_this2.renderPanelBody(panel));
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, panelMarkup);
  };

  _proto.renderPanelHeader = function renderPanelHeader(panel, config) {
    var id = panel.id,
        header = panel.header,
        includedText = panel.includedText;
    var disclaimerGroup = this.props.disclaimerGroup;
    var destinationFeesDisclaimerId = disclaimerGroup.destinationFeesDisclaimerId,
        addPriceDisclaimer = disclaimerGroup.addPriceDisclaimer,
        disclaimerData = disclaimerGroup.disclaimerData;
    return /*#__PURE__*/_react["default"].createElement("h2", {
      key: id
    }, header.label, /*#__PURE__*/_react["default"].createElement("span", {
      className: _configuratorSmallSummary["default"].accordionPrice
    }, this.renderPrice(header.price, includedText, config), config.market === 'us' && id === 'fees' && addPriceDisclaimer && destinationFeesDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "span",
      text: " #" + destinationFeesDisclaimerId + "#",
      addPriceDisclaimer: addPriceDisclaimer,
      disclaimerData: disclaimerData
    })));
  };

  _proto.renderPanelBody = function renderPanelBody(panel) {
    var theme = this.props.theme;
    var id = panel.id,
        body = panel.body,
        changeText = panel.changeText;
    return /*#__PURE__*/_react["default"].createElement("article", {
      key: id,
      className: _configuratorSmallSummary["default"].accordionContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.bodyCopy
    }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: body.description
    })), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        priority: 'low',
        label: changeText
      },
      classes: [_configuratorSmallSummary["default"].changeLink],
      theme: theme,
      clickEvent: body.changeEvent
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        config = _this$props.config,
        direction = _this$props.direction,
        disclaimerGroup = _this$props.disclaimerGroup;
    var panelData = this.state.panelData;
    var _this$props$theme = this.props.theme,
        theme = _this$props$theme === void 0 ? {} : _this$props$theme;
    var isUS = config.market === 'us';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + _configuratorSmallSummary["default"].info,
      dir: direction
    }, !isEmptyArray(panelData) && /*#__PURE__*/_react["default"].createElement("h3", {
      className: theme.labelMedium + " " + theme.marginBottom10
    }, handleNestedProp(data, 'data.customisationTitle')), /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
      multiselectable: false,
      expectedPanelHeight: "xl",
      theme: theme
    }, this.renderPanels(panelData, config)), isUS && data.totalPrice && data.totalPrice.value !== 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorSmallSummary["default"].priceWrapper
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: theme.smallType
    }, data.msrpLabel, /*#__PURE__*/_react["default"].createElement("span", {
      className: _configuratorSmallSummary["default"].msrpPane
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: data.totalPrice.value,
        currency: 'USD',
        locale: 'en-US',
        displayValue: null
      },
      addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
      priceDisclaimerId: disclaimerGroup.msrpDisclaimerId,
      disclaimerData: disclaimerGroup.disclaimerData
    })))));
  };

  return AccordionWrapper;
}(_react["default"].Component);

AccordionWrapper.displayName = 'AccordionWrapper';

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(AccordionWrapper);

exports["default"] = _default;